<section>
    <dx-data-grid
        #dxAdminUsersDataGrid
        id="adminUsersDataGrid"
        keyExpr="userId"
        [dataSource]="dataGridSource"
        [showColumnLines]="false"
        [showRowLines]="true"
        [showBorders]="false"
        (onRowPrepared)="dxGridRowPrepared($event)"
        (onOptionChanged)="onSearchValueChanged($event)"   
        (onContextMenuPreparing)="dxOnContextMenuPreparing($event)">
        
        <dxo-data-grid-load-panel [enabled]="true"></dxo-data-grid-load-panel>

        <dxo-data-grid-search-panel
            [visible]="true"
            alignment="left"
            [text]="userFilterSettings || ''"
            [highlightSearchText]="false"
            placeholder="Search Users by First Name, Last Name, or Email..."
            width="400">
        </dxo-data-grid-search-panel>

        <dxo-data-grid-toolbar>
            <dxi-data-grid-item name="searchPanel" location="before"></dxi-data-grid-item>
            <dxi-data-grid-item location="after">
                <dx-select-box
                    width="130"
                    [items]="activeFilterItems"
                    [inputAttr]="{ 'aria-label': 'Status filter' }"
                    displayExpr="text"
                    valueExpr="value"
                    [value]="selectedActiveFilter"
                    (onValueChanged)="activeDropdownChanged($event)">
                </dx-select-box>
            </dxi-data-grid-item>
        </dxo-data-grid-toolbar>

        <dxi-data-grid-column cssClass="dx-grid-cell" caption="User Name" alignment="left" width="200" dataType="string"
            cellTemplate="userNameTemplate"
            allowSorting="true"
            [calculateCellValue]="dxCalculateUserNameCellValue"
            [calculateSortValue]="dxCalculateUserNameSortValue"
            [calculateFilterExpression]="dxCalculateUserNameFilter">
            <div *dxTemplate="let cellData of 'userNameTemplate'">
                <a [href]="['#/useraccount/admin/users/' + cellData.row.data.userId]">
                    <div class="user-name">{{ cellData.row.data.firstName }} {{ cellData.row.data.lastName }}</div>
                </a>
            </div>
        </dxi-data-grid-column>

        <dxi-data-grid-column cssClass="dx-grid-cell" dataField="email" caption="Email" alignment="left" width="240"></dxi-data-grid-column>

        <dxi-data-grid-column cssClass="dx-grid-cell" dataType="string" dataField="userWorkspaceCount" caption="Portfolios" alignment="left" cellTemplate="userWorkspaceCountTemplate">
            <div *dxTemplate="let cellData of 'userWorkspaceCountTemplate'">                
                <div>{{ cellData.value }} Portfolios</div>                
            </div>
        </dxi-data-grid-column>
        <dxi-data-grid-column cssClass="dx-grid-cell" dataType="string" dataField="userPropertyCount" caption="Properties" alignment="left" cellTemplate="userPropertyCountTemplate">
            <div *dxTemplate="let cellData of 'userPropertyCountTemplate'">                
                <div>{{ cellData.value }} Properties</div>                
            </div>
        </dxi-data-grid-column>
        <dxi-data-grid-column cssClass="dx-grid-cell" dataField="joinedOn" caption="Joined On" dataType="date" alignment="left"></dxi-data-grid-column>       
        <dxi-data-grid-column cssClass="dx-grid-cell" dataField="lastLogin" caption="Last Login" dataType="date" alignment="left"></dxi-data-grid-column>       

        <dxi-data-grid-column cssClass="dx-grid-cell" dataType="string" dataField="isActive" caption="Status" alignment="left" cellTemplate="activeTemplate"></dxi-data-grid-column>            
        <div *dxTemplate="let cellData of 'activeTemplate'">
            <div *ngIf="cellData.row.data.isActive">
                <span class="status-badge badge-active">Active</span>
            </div>
            <div *ngIf="!cellData.row.data.isActive">
                <span class="status-badge badge-inactive">Inactive</span>
            </div>
        </div>

        <dxi-data-grid-column cssClass="dx-grid-cell" alignment="right" cellTemplate="userId">
            <div *dxTemplate="let cellData of 'userId'">                
                <dx-button 
                    id="btnShowActionMenu"
                    hint="Action Menu"
                    [hoverStateEnabled]="false"
                    [activeStateEnabled]="false"
                    stylingMode="text" 
                    type="normal" 
                    icon="overflow" 
                    (onClick)="showActionMenu($event)">
                </dx-button>                  
            </div>
        </dxi-data-grid-column>

        <!-- <dxo-scrolling rowRenderingMode="virtual"> </dxo-scrolling> -->
        <dxo-data-grid-paging [pageSize]="10"> </dxo-data-grid-paging>
        <dxo-data-grid-pager
            [visible]="true"
            [allowedPageSizes]="[10, 25, 50]"
            [displayMode]="'compact'"
            [showPageSizeSelector]="true"
            [showInfo]="true"
            [showNavigationButtons]="true">
        </dxo-data-grid-pager>
    </dx-data-grid>
</section>
